export default __webpack_public_path__ + "static/media/the-sprint-team.6bfca63b.pdf";